<automata-automation-replacement-chips
  label="AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.PIPELINE"
  [dataService]="pipelineService"
  [formControl]="pipelineControl"
  [supportDataPassing]="false"
  [isRequired]="true"
  [multiple]="false"
  (finishedInitialLoading)="finishedLoading()"
></automata-automation-replacement-chips>
@if (!loadingValues() && showStageSelection) {
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.STAGE"
    [dataService]="stageOptionsDataService"
    [formControl]="stageControl"
    [supportDataPassing]="false"
    [isRequired]="showStageSelection"
    [multiple]="false"
  ></automata-automation-replacement-chips>
}
